import { Link } from "react-router-dom";
import { BRAND } from "@/config/site";

// Official supplied brand files only. light = white bg, dark = #0A3622 bg.
const SRC = {
  light: "/brand/logo-horizontal.png",
  dark: "/brand/logo-horizontal-white.png",
};
const MARK_SRC = { light: "/brand/mark.svg", dark: "/brand/mark-white.svg" };

export function LogoMark({ variant = "light", testid = "logo-mark", className = "" }) {
  return (
    <img
      src={MARK_SRC[variant]}
      alt={BRAND.LOGO_ALT}
      width="32"
      height="32"
      className={`block w-8 h-8 shrink-0 ${className}`}
      data-testid={testid}
    />
  );
}

export default function Logo({ variant = "light", testid = "logo", to = "/", as: As = Link, className = "" }) {
  const img = (
    <img
      src={SRC[variant]}
      alt={BRAND.LOGO_ALT}
      width="168"
      height="32"
      className={`block h-8 w-auto max-[359px]:h-7 ${className}`}
      data-testid={testid}
    />
  );
  if (!As) return img;
  return (
    <As to={to} aria-label="Ascentremit home" className="inline-block shrink-0">
      {img}
    </As>
  );
}
